module.exports = __webpack_public_path__ + "static/img/19017B_6_C_20230526_fit.c16feae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19017B_6_C_20230526_fit.png
// module id = O54D
// module chunks = 0